<template>
  <div>
    <b-overlay
      :show="loading"
      rounded="sm"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
    >
      <b-tabs
        pills
        fill
        vertical
        end
        small
        card
        nav-wrapper-class="rounded bg-white p-0 m-0 mt-2 shadow"
        nav-class="pt-1 px-1"
      >
        <b-tab
          class="pl-0"
          active
        >
          <template #title>
            <div class="w-100 d-flex align-items-center">
              <feather-icon icon="EditIcon" />
              <span>Ürün Bilgisi</span>
            </div>
          </template>
          <product-card :submit-form="submitForm" />
        </b-tab>
        <b-tab
          class="pl-0"
          lazy
          :disabled="!dataItem.id"
        >
          <template #title>
            <div class="w-100 d-flex align-items-center">
              <feather-icon icon="MenuIcon" />
              <span>Ürün İçeriği</span>
            </div>
          </template>
          <material-card />
        </b-tab>
        <b-tab
          class="pl-0"
          lazy
          :disabled="!dataItem.id"
        >
          <template #title>
            <div class="w-100 d-flex align-items-center">
              <feather-icon icon="PercentIcon" />
              <span>Kalori</span>
            </div>
          </template>
          <calorie-card />
        </b-tab>
        <b-tab
          class="pl-0"
          lazy
          :disabled="!dataItem.id"
        >
          <template #title>
            <div class="w-100 d-flex align-items-center">
              <feather-icon icon="ClockIcon" />
              <span>Servis Süresi</span>
            </div>
          </template>
          <times-card />
        </b-tab>
        <b-tab
          class="pl-0"
          lazy
          :disabled="!dataItem.id"
        >
          <template #title>
            <div class="w-100 d-flex align-items-center">
              <feather-icon icon="BookIcon" />
              <span>Alerjen</span>
            </div>
          </template>
          <allergen-card />
        </b-tab>
        <b-tab
          class="pl-0"
          lazy
          :disabled="!dataItem.id"
        >
          <template #title>
            <div class="w-100 d-flex align-items-center">
              <feather-icon icon="PackageIcon" />
              <span>Porsiyon</span>
            </div>
          </template>
          <portion-card />
        </b-tab>
        <b-tab
          class="pl-0"
          lazy
          :disabled="!dataItem.id"
        >
          <template #title>
            <div class="w-100 d-flex align-items-center">
              <feather-icon icon="DollarSignIcon" />
              <span>Fiyatlandırma</span>
            </div>
          </template>
          <price-card />
        </b-tab>
        <b-tab
          class="pl-0"
          lazy
          :disabled="!dataItem.id"
        >
          <template #title>
            <div class="w-100 d-flex align-items-center">
              <feather-icon icon="CameraIcon" />
              <span>Ürün Fotoğrafları</span>
            </div>
          </template>
          <gallery-card />
        </b-tab>
      </b-tabs>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTabs, BTab, BOverlay,
} from 'bootstrap-vue'
import ProductCard from '@/views/Products/elements/ProductCard.vue'
import MaterialCard from '@/views/Products/elements/MaterialCard.vue'
import CalorieCard from '@/views/Products/elements/CalorieCard.vue'
import TimesCard from '@/views/Products/elements/TimesCard.vue'
import AllergenCard from '@/views/Products/elements/AllergenCard.vue'
import PortionCard from '@/views/Products/elements/PortionCard.vue'
import PriceCard from '@/views/Products/elements/PriceCard.vue'
import GalleryCard from '@/views/Products/elements/GalleryCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BTabs,
    BTab,
    BOverlay,
    ProductCard,
    MaterialCard,
    CalorieCard,
    TimesCard,
    AllergenCard,
    PortionCard,
    PriceCard,
    GalleryCard,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      variant: 'transparent',
      opacity: 0.9,
      blur: '2px',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
    loading() {
      return this.$store.getters['products/loading']
    },
  },
  mounted() {
    this.dataItem.submitStatus = false
  },
}
</script>
